function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import "../polizaRenewal.scss";
import Select from "react-select";
import CurrencyInput from "../../../helperComponents/CurrencyInput/CurrencyInput";
import { getCurrencyByString } from "../../../utils/currency";
import Footer from "./Footer";
import { update, create, finish, reset, getVersionsQueryKey, getShowQueryKey } from "../actions/PolizaRenewalActions";
import { filename } from "../../../utils/InputUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";

var PolizaRenewalForm = function PolizaRenewalForm(props) {
  var _polizaRenewal$poliza, _polizaRenewal$poliza2, _polizaRenewal$poliza3, _polizaRenewal$poliza4, _polizaRenewal$poliza5, _polizaRenewal$poliza6, _polizaRenewal$poliza7, _polizaRenewal$poliza8, _polizaRenewal$poliza9, _polizaRenewal$poliza10, _polizaRenewal$poliza11, _polizaRenewal$poliza12;

  var token = props.token,
      polizaRenewal = props.polizaRenewal,
      conditions = props.conditions,
      conditionUpdateReasons = props.conditionUpdateReasons,
      clientRejectsRenewalReasons = props.clientRejectsRenewalReasons,
      companyRejectsRenewalReasons = props.companyRejectsRenewalReasons,
      _onChange = props.onChange;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      companyConditionsDocument = _useState2[0],
      setCompanyConditionsDocument = _useState2[1];

  useEffect(function () {
    var _polizaRenewal$compan;

    setCompanyConditionsDocument((_polizaRenewal$compan = polizaRenewal.company_conditions_document) === null || _polizaRenewal$compan === void 0 ? void 0 : _polizaRenewal$compan.company_conditions_document);
  }, [polizaRenewal]);
  var currency = getCurrencyByString(polizaRenewal.poliza.currency);
  var affects_percent = ((_polizaRenewal$poliza = polizaRenewal.poliza) === null || _polizaRenewal$poliza === void 0 ? void 0 : (_polizaRenewal$poliza2 = _polizaRenewal$poliza.commission) === null || _polizaRenewal$poliza2 === void 0 ? void 0 : _polizaRenewal$poliza2.affects_net_bonus) && ((_polizaRenewal$poliza3 = polizaRenewal.poliza) === null || _polizaRenewal$poliza3 === void 0 ? void 0 : (_polizaRenewal$poliza4 = _polizaRenewal$poliza3.commission) === null || _polizaRenewal$poliza4 === void 0 ? void 0 : _polizaRenewal$poliza4.affects_net_bonus) / ((_polizaRenewal$poliza5 = polizaRenewal.poliza) === null || _polizaRenewal$poliza5 === void 0 ? void 0 : (_polizaRenewal$poliza6 = _polizaRenewal$poliza5.commission) === null || _polizaRenewal$poliza6 === void 0 ? void 0 : _polizaRenewal$poliza6.net_bonus);
  var exempt_percent = ((_polizaRenewal$poliza7 = polizaRenewal.poliza) === null || _polizaRenewal$poliza7 === void 0 ? void 0 : (_polizaRenewal$poliza8 = _polizaRenewal$poliza7.commission) === null || _polizaRenewal$poliza8 === void 0 ? void 0 : _polizaRenewal$poliza8.exempt_net_bonus) && ((_polizaRenewal$poliza9 = polizaRenewal.poliza) === null || _polizaRenewal$poliza9 === void 0 ? void 0 : (_polizaRenewal$poliza10 = _polizaRenewal$poliza9.commission) === null || _polizaRenewal$poliza10 === void 0 ? void 0 : _polizaRenewal$poliza10.exempt_net_bonus) / ((_polizaRenewal$poliza11 = polizaRenewal.poliza) === null || _polizaRenewal$poliza11 === void 0 ? void 0 : (_polizaRenewal$poliza12 = _polizaRenewal$poliza11.commission) === null || _polizaRenewal$poliza12 === void 0 ? void 0 : _polizaRenewal$poliza12.net_bonus) || 0;
  var queryClient = useQueryClient();

  var _useMutation = useMutation({
    mutationKey: getShowQueryKey(polizaRenewal.id),
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, errorData, _contentType, textResponse, contentType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!polizaRenewal.id) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return update(polizaRenewal, token);

              case 3:
                _context.t0 = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return create(polizaRenewal, token);

              case 8:
                _context.t0 = _context.sent;

              case 9:
                response = _context.t0;

                if (response.ok) {
                  _context.next = 30;
                  break;
                }

                // Try to parse error response
                _contentType = response.headers.get("content-type");

                if (!(_contentType && _contentType.includes("application/json"))) {
                  _context.next = 24;
                  break;
                }

                _context.prev = 13;
                _context.next = 16;
                return response.json();

              case 16:
                errorData = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t1 = _context["catch"](13);
                errorData = {
                  message: "Error ".concat(response.status, ": ").concat(response.statusText)
                };

              case 22:
                _context.next = 29;
                break;

              case 24:
                _context.next = 26;
                return response.text();

              case 26:
                textResponse = _context.sent;
                errorData = {
                  message: "Error del servidor (".concat(response.status, "): ").concat(response.statusText)
                };
                console.error("Server returned non-JSON response:", textResponse.substring(0, 500));

              case 29:
                throw new Error(errorData.message || errorData.errors || "Error al guardar: ".concat(response.status));

              case 30:
                // Parse successful response
                contentType = response.headers.get("content-type");

                if (!(contentType && contentType.includes("application/json"))) {
                  _context.next = 37;
                  break;
                }

                _context.next = 34;
                return response.json();

              case 34:
                return _context.abrupt("return", _context.sent);

              case 37:
                throw new Error("Respuesta del servidor no es JSON");

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[13, 19]]);
      }));

      function mutationFn() {
        return _mutationFn.apply(this, arguments);
      }

      return mutationFn;
    }(),
    onSuccess: function onSuccess(data) {
      if (data && data.poliza_renewal) {
        _onChange(data.poliza_renewal);

        queryClient.invalidateQueries({
          queryKey: getVersionsQueryKey(polizaRenewal.id)
        }); // Show success message

        // Show success message
        alert("Renovación guardada correctamente");
      }
    },
    onError: function onError(error) {
      console.error("Error saving poliza renewal:", error);
      var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || "Error al guardar la renovación. Por favor, intenta de nuevo.";
      alert(errorMessage);
    }
  }),
      isLoadingSave = _useMutation.isLoading,
      isErrorSave = _useMutation.isError,
      errorSave = _useMutation.error,
      savePolizaRenewal = _useMutation.mutate,
      savedPolizaRenewal = _useMutation.data;

  var _useMutation2 = useMutation({
    mutationKey: getShowQueryKey(polizaRenewal.id),
    mutationFn: function () {
      var _mutationFn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response, errorData, _contentType2, textResponse, contentType;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return finish(polizaRenewal, token);

              case 2:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 23;
                  break;
                }

                // Try to parse error response
                _contentType2 = response.headers.get("content-type");

                if (!(_contentType2 && _contentType2.includes("application/json"))) {
                  _context2.next = 17;
                  break;
                }

                _context2.prev = 6;
                _context2.next = 9;
                return response.json();

              case 9:
                errorData = _context2.sent;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](6);
                errorData = {
                  message: "Error ".concat(response.status, ": ").concat(response.statusText)
                };

              case 15:
                _context2.next = 22;
                break;

              case 17:
                _context2.next = 19;
                return response.text();

              case 19:
                textResponse = _context2.sent;
                errorData = {
                  message: "Error del servidor (".concat(response.status, "): ").concat(response.statusText)
                };
                console.error("Server returned non-JSON response:", textResponse.substring(0, 500));

              case 22:
                throw new Error(errorData.message || errorData.errors || "Error al finalizar: ".concat(response.status));

              case 23:
                // Parse successful response
                contentType = response.headers.get("content-type");

                if (!(contentType && contentType.includes("application/json"))) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 27;
                return response.json();

              case 27:
                return _context2.abrupt("return", _context2.sent);

              case 30:
                throw new Error("Respuesta del servidor no es JSON");

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 12]]);
      }));

      function mutationFn() {
        return _mutationFn2.apply(this, arguments);
      }

      return mutationFn;
    }(),
    onSuccess: function onSuccess(data) {
      if (data && data.poliza_renewal) {
        _onChange(data.poliza_renewal);

        queryClient.invalidateQueries({
          queryKey: getVersionsQueryKey(polizaRenewal.id)
        });
        alert("Renovación finalizada correctamente");
      }
    },
    onError: function onError(error) {
      console.error("Error finishing poliza renewal:", error);
      var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || "Error al finalizar la renovación. Por favor, intenta de nuevo.";
      alert(errorMessage);
    }
  }),
      isLoadingFinish = _useMutation2.isLoading,
      isErrorFinish = _useMutation2.isError,
      errorFinish = _useMutation2.error,
      finishPolizaRenewal = _useMutation2.mutate,
      finishedPolizaRenewal = _useMutation2.data;

  var _useMutation3 = useMutation({
    mutationKey: getShowQueryKey(polizaRenewal.id),
    mutationFn: function mutationFn() {
      return reset(polizaRenewal, token);
    },
    onSuccess: function onSuccess(response) {
      // It always enter here, onError does not work
      if (response.status == 200) {
        response.json().then(function (data) {
          _onChange(data.poliza_renewal);
        })["catch"](function (error) {
          console.error(error);
        });
        queryClient.invalidateQueries({
          queryKey: getVersionsQueryKey(polizaRenewal.id)
        });
      } else {// TODO: Manage errors
      }
    }
  }),
      isLoadingReset = _useMutation3.isLoading,
      isErrorReset = _useMutation3.isError,
      errorReset = _useMutation3.error,
      resetPolizaRenewal = _useMutation3.mutate,
      resetPolizaRenewalData = _useMutation3.data;

  var renderNewPrimaForm = function renderNewPrimaForm() {
    var _polizaRenewal$poliza13, _polizaRenewal$poliza14, _polizaRenewal$poliza15, _polizaRenewal$poliza16, _polizaRenewal$poliza17, _polizaRenewal$poliza18, _polizaRenewal$poliza19, _polizaRenewal$poliza20, _polizaRenewal$poliza21, _polizaRenewal$poliza22, _polizaRenewal$poliza23, _polizaRenewal$poliza24;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row gy-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza13 = polizaRenewal.poliza) === null || _polizaRenewal$poliza13 === void 0 ? void 0 : (_polizaRenewal$poliza14 = _polizaRenewal$poliza13.commission) === null || _polizaRenewal$poliza14 === void 0 ? void 0 : _polizaRenewal$poliza14.affects_net_bonus,
      currency: currency,
      disabled: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza15 = polizaRenewal.poliza) === null || _polizaRenewal$poliza15 === void 0 ? void 0 : (_polizaRenewal$poliza16 = _polizaRenewal$poliza15.commission) === null || _polizaRenewal$poliza16 === void 0 ? void 0 : _polizaRenewal$poliza16.exempt_net_bonus,
      currency: currency,
      disabled: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza17 = polizaRenewal.poliza) === null || _polizaRenewal$poliza17 === void 0 ? void 0 : (_polizaRenewal$poliza18 = _polizaRenewal$poliza17.commission) === null || _polizaRenewal$poliza18 === void 0 ? void 0 : _polizaRenewal$poliza18.net_bonus,
      currency: currency,
      disabled: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "row gy-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva prima neta afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: polizaRenewal.affects_net_bonus || ((_polizaRenewal$poliza19 = polizaRenewal.poliza) === null || _polizaRenewal$poliza19 === void 0 ? void 0 : (_polizaRenewal$poliza20 = _polizaRenewal$poliza19.commission) === null || _polizaRenewal$poliza20 === void 0 ? void 0 : _polizaRenewal$poliza20.affects_net_bonus),
      currency: currency,
      onValueChange: function onValueChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          affects_net_bonus: parseFloat(value.replace(",", ".")),
          net_bonus: parseFloat(value.replace(",", ".")) + polizaRenewal.exempt_net_bonus
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva prima neta exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: polizaRenewal.exempt_net_bonus || ((_polizaRenewal$poliza21 = polizaRenewal.poliza) === null || _polizaRenewal$poliza21 === void 0 ? void 0 : (_polizaRenewal$poliza22 = _polizaRenewal$poliza21.commission) === null || _polizaRenewal$poliza22 === void 0 ? void 0 : _polizaRenewal$poliza22.exempt_net_bonus),
      currency: currency,
      onValueChange: function onValueChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          exempt_net_bonus: parseFloat(value.replace(",", ".")),
          net_bonus: parseFloat(value.replace(",", ".")) + polizaRenewal.affects_net_bonus
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 col-lg-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva prima neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      value: polizaRenewal.net_bonus || ((_polizaRenewal$poliza23 = polizaRenewal.poliza) === null || _polizaRenewal$poliza23 === void 0 ? void 0 : (_polizaRenewal$poliza24 = _polizaRenewal$poliza23.commission) === null || _polizaRenewal$poliza24 === void 0 ? void 0 : _polizaRenewal$poliza24.net_bonus),
      currency: currency,
      disabled: true
    }))));
  };

  var renderPolizaRenewalForm = function renderPolizaRenewalForm() {
    var _polizaRenewal$poliza25, _polizaRenewal$poliza26, _polizaRenewal$poliza27, _polizaRenewal$poliza28;

    if (polizaRenewal && (!((_polizaRenewal$poliza25 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza25 !== void 0 && (_polizaRenewal$poliza26 = _polizaRenewal$poliza25.commission) !== null && _polizaRenewal$poliza26 !== void 0 && _polizaRenewal$poliza26.net_bonus) || !((_polizaRenewal$poliza27 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza27 !== void 0 && (_polizaRenewal$poliza28 = _polizaRenewal$poliza27.commission) !== null && _polizaRenewal$poliza28 !== void 0 && _polizaRenewal$poliza28.affects_net_bonus))) {
      return /*#__PURE__*/React.createElement("p", null, "No es posible ingresar condiciones de renovaci\xF3n de una p\xF3liza sin prima ingresada.");
    }

    var inspectionFieldId = "inspection-needed-".concat(polizaRenewal.id);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row gy-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Condici\xF3n de renovaci\xF3n"), /*#__PURE__*/React.createElement(Select, {
      options: conditions,
      defaultValue: conditions.find(function (condition) {
        return polizaRenewal.condition === condition.value;
      }),
      name: "polizaRenewal[condition]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona condición de renovación",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "change_conditions" && /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n del cambio de condiciones"), /*#__PURE__*/React.createElement(Select, {
      options: conditionUpdateReasons,
      defaultValue: conditionUpdateReasons.find(function (condition) {
        return polizaRenewal.condition_update_reason === condition.value;
      }),
      name: "polizaRenewal[condition_update_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Seleccione una razón del cambio de condiciones",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition_update_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "client_rejects_renewal" && /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n de rechazo (Cliente)"), /*#__PURE__*/React.createElement(Select, {
      options: clientRejectsRenewalReasons,
      defaultValue: clientRejectsRenewalReasons.find(function (condition) {
        return polizaRenewal.client_rejects_renewal_reason === condition.value;
      }),
      name: "polizaRenewal[client_rejects_renewal_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona razón de rechazo de parte del Cliente...",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          client_rejects_renewal_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "company_rejects_renewal" && /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n de rechazo (Compa\xF1\xEDa)"), /*#__PURE__*/React.createElement(Select, {
      options: companyRejectsRenewalReasons,
      defaultValue: companyRejectsRenewalReasons.find(function (condition) {
        return polizaRenewal.company_rejects_renewal_reason === condition.value;
      }),
      name: "polizaRenewal[company_rejects_renewal_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona razón de rechazo de parte de la Compañía...",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          company_rejects_renewal_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    }))), polizaRenewal.condition === "change_conditions" && polizaRenewal.condition_update_reason === "change_prima" && renderNewPrimaForm(), /*#__PURE__*/React.createElement("div", {
      className: "row gy-3 align-items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-lg-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label d-block"
    }, "Solicitado inspeccionar"), /*#__PURE__*/React.createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/React.createElement("input", {
      id: inspectionFieldId,
      className: "form-check-input",
      type: "checkbox",
      onChange: function onChange(event) {
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          inspection_needed: event.target.checked
        }));
      },
      checked: polizaRenewal.inspection_needed
    }), /*#__PURE__*/React.createElement("label", {
      className: "form-check-label",
      htmlFor: inspectionFieldId
    }, "Inspecci\xF3n requerida"))), /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-lg-8"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Condiciones de la compa\xF1\xEDa"), /*#__PURE__*/React.createElement("input", {
      className: "form-control",
      type: "file",
      onChange: function onChange(event) {
        if (event.target.files && event.target.files.length > 0) {
          _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
            company_conditions_document: event.target.files[0]
          }));

          if (companyConditionsDocument !== null && companyConditionsDocument !== void 0 && companyConditionsDocument.url) {
            setCompanyConditionsDocument(null);
          }
        }
      }
    }), (companyConditionsDocument === null || companyConditionsDocument === void 0 ? void 0 : companyConditionsDocument.url) && /*#__PURE__*/React.createElement("div", {
      className: "mt-2"
    }, /*#__PURE__*/React.createElement("a", {
      href: companyConditionsDocument.url,
      className: "renewalDocumentLink"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M6 2h9l5 5v15a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 2v6h6",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 14h8M8 18h5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })), /*#__PURE__*/React.createElement("span", null, filename(companyConditionsDocument === null || companyConditionsDocument === void 0 ? void 0 : companyConditionsDocument.url.split("/"))))))), /*#__PURE__*/React.createElement("div", {
      className: "row gy-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-6"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label formLabelCompact"
    }, "Detalles de la condici\xF3n"), /*#__PURE__*/React.createElement("textarea", {
      className: "form-control renewalTextarea",
      rows: 4,
      placeholder: "Completar detalles de las condiciones...",
      value: (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.condition_details) || "",
      onChange: function onChange(event) {
        return _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition_details: event.target.value
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-lg-6"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label formLabelCompact"
    }, "Comentarios del cambio"), /*#__PURE__*/React.createElement("textarea", {
      className: "form-control renewalTextarea",
      rows: 4,
      placeholder: "Agregar comentarios al cambio...",
      value: (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.comments) || "",
      onChange: function onChange(event) {
        return _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          comments: event.target.value
        }));
      }
    }))));
  };

  var renderErrors = function renderErrors() {
    var _polizaRenewal$errors;

    if (polizaRenewal !== null && polizaRenewal !== void 0 && (_polizaRenewal$errors = polizaRenewal.errors) !== null && _polizaRenewal$errors !== void 0 && _polizaRenewal$errors.messages) {
      return polizaRenewal.errors.messages.map(function (message, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "alert alert-danger",
          key: "renewal-error-".concat(index)
        }, message);
      });
    }

    return null;
  };

  var cannotEditPolizaRenewal = function cannotEditPolizaRenewal() {
    return (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "renewed" || (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "not_renewed";
  };

  var cannotSaveConditions = function cannotSaveConditions() {
    return (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "with_conditions";
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cntPolizaRenewalForm renewalFormSurface"
  }, /*#__PURE__*/React.createElement("div", {
    className: "renewalFormIntro"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "renewalUnifiedTitle"
  }, "Renovaci\xF3n de p\xF3liza"), /*#__PURE__*/React.createElement("p", {
    className: "renewalFormDescription"
  }, "Actualiza las condiciones y comentarios antes de informar al cliente.")), /*#__PURE__*/React.createElement("div", {
    className: "card renewalCard renewalFormCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody renewalFormCardBody"
  }, renderErrors(), polizaRenewal && renderPolizaRenewalForm()), /*#__PURE__*/React.createElement("div", {
    className: "card-footer cardFooter renewalFormCardFooter"
  }, isLoadingSave ? /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-muted",
    disabled: isLoadingSave,
    type: "button"
  }, "Guardando...") : /*#__PURE__*/React.createElement("div", {
    className: "renewalActions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-muted",
    type: "button",
    onClick: function onClick() {
      if (!cannotEditPolizaRenewal()) {
        savePolizaRenewal();
      }
    },
    disabled: cannotEditPolizaRenewal()
  }, "Guardar"), isLoadingFinish ? /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-primary",
    disabled: isLoadingFinish,
    type: "button"
  }, "Marcando condici\xF3n cargada...") : /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-primary",
    type: "button",
    onClick: function onClick() {
      if (!cannotEditPolizaRenewal() && !cannotSaveConditions()) {
        finishPolizaRenewal();
      }
    },
    disabled: cannotEditPolizaRenewal() || cannotSaveConditions()
  }, cannotSaveConditions() ? "Condiciones cargadas" : "Marcar condición cargada"), isLoadingReset ? /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-primary",
    disabled: isLoadingReset,
    type: "button"
  }, "Reiniciando...") : /*#__PURE__*/React.createElement("button", {
    className: "btn btn-renewal-primary",
    type: "button",
    onClick: function onClick() {
      return resetPolizaRenewal();
    }
  }, "Reiniciar")))), /*#__PURE__*/React.createElement(Footer, {
    polizaRenewal: polizaRenewal
  }));
};

export default PolizaRenewalForm;